import { useEffect, useState } from "react";
import { DateUtil } from "../utils/DateUtil";
import { WeeklyHighlightModel } from "../models/WeeklyHighlightModel";

type CacheEntry = {
    highlight?: WeeklyHighlightModel;
    ts: number;
};

let highlightCache: CacheEntry = { highlight: undefined, ts: 0 };

export function useHighlight(options?: { maxAgeMs?: number }) {

    const maxAgeMs = options?.maxAgeMs ?? (60000 * 60); // 1h

    const cached = highlightCache;
    const [highlight, setHighlight] = useState<WeeklyHighlightModel | undefined>(cached?.highlight ?? undefined);
    const [loading, setLoading] = useState<boolean>(!cached);

    useEffect(() => {
        const now = Date.now();
        const cacheHit = highlightCache;
        const fresh = cacheHit && now - cacheHit.ts < maxAgeMs;
        
        if (fresh) {
            setHighlight(cacheHit!.highlight);
            setLoading(false);
            return;
        }

        fetchHighlight();
    }, []);

    const fetchHighlight = async () => {
        setLoading(true);
        try {
            const response = await fetch("/api/events/weeklyHighlight?date=" + DateUtil.formatDate(new Date()));
            if(response.ok) {
                const data = await response.json();
                highlightCache = { highlight: data, ts: Date.now() };
                setHighlight(data);
            }
            else {
                highlightCache = { highlight: undefined, ts: Date.now() };
                setHighlight(undefined);
            }
        }
        catch(err: any) {
            console.error('Error fetching highlight:', err);
        }
        finally {
            setLoading(false);
        }
    };

    return {
        highlight,
        loading
    };

}
